<script>
    import {HeroForm} from '../store.js';
    import {getContext} from 'svelte';
    import Navbar from '../navbar/navbar.svelte';
    import Footer from '../landing_page/footer.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import SubmitForm from './submit_form.svelte';
    import Autocomplete from '../component/autocomplete.svelte';
    import {getCountry, getPhone} from '../utils';
    let code;
    let CountryNamePlaceHolder;
    let CountryName;
    let saveCode;
    let CountryCodePlaceHolder;
    const {title} = rpcjs.props;
    title.set('Form | Fee');
    const {url} = getContext('APP');
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    const formData = {
        name: '',
        email: '',
        country: '',
        countryCode: '',
        phoneNumber: '',
        aboutYourSelf: '',
    };
    if (HeroForm.get() == undefined) {
        HeroForm.update((n)=> n={session: '', name: '', email: '', country: '', countryCode: '', city: '', phoneNumber: '',
            dateOfBirth: '', gender: '', technicalSkill: '', englishAbility: '', industry: '', industryOther: '',
            business: '', visa: '', aid: '', referalName: '', hearAbout: '', hearAboutOthers: '',
            startup: '', aboutYourSelf: '', portfolioURL: '', buildingPlan: '', travelBudget: '',
            buildingWeeks: '', invitedtoProgram: '', ackowledged: ''});
    } else {
        formData.name = HeroForm.get().name;
        formData.email = HeroForm.get().email;
        CountryName = HeroForm.get().country;
        formData.countryCode = HeroForm.get().countryCode;
        formData.phoneNumber = HeroForm.get().phoneNumber;
        formData.aboutYourSelf = HeroForm.get().aboutYourSelf;
    }
    $: if (HeroForm.get() != undefined) {
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: formData.name, email: formData.email,
            country: CountryName, countryCode: formData.countryCode,
            city: HeroForm.get().city, phoneNumber: formData.phoneNumber, dateOfBirth: HeroForm.get().dateOfBirth,
            gender: HeroForm.get().gender,
            technicalSkill: HeroForm.get().technicalSkill, englishAbility: HeroForm.get().englishAbility,
            industry: HeroForm.get().industry, industryOther: HeroForm.get().industryOther,
            business: HeroForm.get().business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: '',
            aboutYourSelf: formData.aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged});
    }
    /**
     *
     * @param {string}object
     */
    async function SaveData() {
        if (formNo.name === 'VCX') {
            location.href='/apply?name=VCX&FormNo=submitform';
        } else if (formNo.name === 'investor') {
            location.href='/apply?name=investor&FormNo=submitform';
        } else if (formNo.name === 'Government') {
            location.href='/apply?name=Government&FormNo=submitform';
        }
    }
    $: if ((CountryName != undefined) && (CountryName != '') && (code != CountryName) ) {
        formData.country = CountryName;
    } else if ( (CountryName == undefined) && (formData.country != '')) {
        CountryName = formData.country;
    }
    $: if ((saveCode != undefined) && (saveCode != '')) {
        formData.countryCode = saveCode;
    } else if ( (saveCode == undefined) && (formData.countryCode != '')) {
        saveCode = formData.countryCode;
    }
    $: if (formData.country != '') {
        CountryNamePlaceHolder= formData.country;
    }
    $: if (formData.countryCode != '') {
        CountryCodePlaceHolder = formData.countryCode;
    }
    /**
     *
     *
     */
    function goBack() {
        location.href='/applyProgram';
    }
    // <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
    
</script>

<section>
    <div class="desktop">
        <Navbar />
    </div>
    <div class="mobile back-img">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
    </div>
    <div class="desktop">
        <div class="heading">
            <p>Apply to DraperU</p>
        </div>
        <div class="pre">
            <p>go from an idea to a product ready to pitch to investors</p>
        </div>
        <div class="back-div">
            <div>
                <div class="Form-Fee">
                    <p>Form Fee</p>
                </div>
                <div class="Form-Fee_x">
                    <p>
                        Application Form costs 5$.<br /> After you submit your form
                        you will get a confirmation Email.
                    </p>
                </div>
            </div>
            <div class="front-div">
                <div class="back-arrow" on:click={() => ( goBack())}>
                    <img src="images/apply/back_arrow.svg" alt="">
                </div>
                <div>
                    <form on:submit|preventDefault={SaveData}>
                        <div>
                            <div style="display:flex;">
                                <div style="margin-left: 4.96vw;">
                                    <label for="f_name">Your Full Name</label>
                                    <div>
                                        <input
                                            required
                                            class="input_desktop"
                                            type="text"
                                            id="f_name"
                                            placeholder="Olive Yew"
                                            style="width: 18.915vw;"
                                            bind:value={formData.name}
                                        />
                                    </div>
                                </div>

                                <div style="margin-left: 4.8vw;">
                                    <label for="email">E-Mail</label>
                                    <div>
                                        <input
                                            required
                                            class="input_desktop"
                                            style="width: 25.132vw;"
                                            type="email"
                                            id="email"
                                            placeholder="example@domain.com"
                                            bind:value={formData.email}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style="display:flex;">
                                <div style="margin-left: 4.96vw;">
                                    <label for="country">Country</label>
                                    <div style="margin-top: 0.397vw;">
                                        <Autocomplete 
                                        id="ac-location"
                                        placeholder={CountryNamePlaceHolder}
                                        searchFunction={getCountry}
                                        bind:value={CountryName}
                                        bind:valueName={code}
                                    />
                                    </div>
                                </div>

                                <div style="margin-left: 4.8vw;">
                                    <label for="country_code">CountryCode</label>
                                    <div style="margin-top: 0.397vw;">
                                        <Autocomplete 
                                            id="ac-location"
                                            placeholder={CountryCodePlaceHolder}
                                            searchFunction={getPhone}
                                            bind:value={saveCode}
                                        />                                  
                                    </div>
                                </div>

                                <div style="margin-left: 4.8vw;">
                                    <label for="Pno">Phone Number</label>
                                    <div>
                                        <input
                                            required
                                            class="input_desktop"
                                            type="number"
                                            id="f_name"
                                            placeholder="xxxxxxxxxxx"
                                            style="width: 18.915vw;"
                                            bind:value={formData.phoneNumber}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style="margin-left: 4.8vw;">
                                <label for="Yself"
                                    >Tell us a little bit about yourself.</label
                                >

                                <div>
                                    <input
                                        required
                                        class="input_desktop"
                                        type="text"
                                        id="Yself"
                                        placeholder=""
                                        style="width: 40.476vw;"
                                        bind:value={formData.aboutYourSelf}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 5vw; margin-top: 5vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                                        border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                            >Next</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        {#if formNo.FormNo === 'submitform'}
            <SubmitForm />
        {/if}
    </div>
    <div class="mobile">
        <div class="heading-mobile">
            <p>Apply to <br /> DraperU</p>
        </div>
        <div class="back-div-mobile">
            <div style="position: absolute;">
                <p class="Form-Fee-mobile">Form Fee</p>

                <p class="Form-Fee_x-mobile">
                    Application Form costs 5$. After you submit your form you
                    will get a confirmation Email.
                </p>
            </div>

            <div class="front-div-mobile">
                <form on:submit|preventDefault={SaveData}>
                    <div>
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Your Full Name</p>    
                            <div>
                                <input
                                    required
                                    style="width: 50.0vw;"
                                    class="input-mobile"
                                    type="text"
                                    id="f_name"
                                    placeholder="Olive Yew"
                                    bind:value={formData.name}
                                />
                            </div>
                        </div>
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">E-Mail</p>
    
                            <div>
                                <input
                                    required
                                    class="input-mobile"
                                    style="width: 71.0vw;"
                                    type="email"
                                    id="email"
                                    placeholder="example@domain.com"
                                    bind:value={formData.email}
                                />
                            </div>
                        </div>
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Country</p>
                            <div>
                                <Autocomplete 
                                    id="ac-location"
                                    placeholder={CountryNamePlaceHolder}
                                    searchFunction={getCountry}
                                    bind:value={CountryName}
                                    bind:valueName={code}
                                />
                            </div>
                        </div>
    
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">CountryCode</p>
                            <div>
                                <Autocomplete 
                                    id="ac-location"
                                    placeholder={CountryCodePlaceHolder}
                                    searchFunction={getPhone}
                                    bind:value={saveCode}
                                />   
                            </div>
                        </div>
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Phone Number</p>
    
                            <div>
                                <input
                                    required
                                    class="input-mobile"
                                    style="width: 50.0vw;"
                                    type="number"
                                    id="email"
                                    placeholder="xxxxxxxxxxx"
                                    bind:value={formData.phoneNumber}
                                />
                            </div>
                        </div>
    
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">
                                Tell us a little bit about yourself.
                            </p>
    
                            <div>
                                <input
                                    required
                                    style="width: 71.0vw;"
                                    class="input-mobile"
                                    type="text"
                                    id="Yself"
                                    placeholder=""
                                    bind:value={formData.aboutYourSelf}
                                />
                            </div>
                        </div>
                    </div>
    
                    <div style="margin-left: 8vw; margin-top: 5vw; display: flex; gap: 4.673vw;">
                        <button
                            style=" background-color: rgba(60, 116, 192, 1);
                                border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 2vw 8vw; color: white; font-size: 3.889vw;"
                            >Next</button>
                        <div class="back-arrow-mob" on:click={() => ( goBack())}>
                            <img src="images/apply/back_button.svg" alt="">
                        </div>
                    </div>
                </form>
            </div>
        </div>
        {#if formNo.FormNo === 'submitform'}
            <SubmitForm />
        {/if}
    </div>
    <div style="margin-top: -1vw;">
        <Footer />
    </div>
    
</section>

<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number]{
        -moz-appearance: textfield;
    }
    .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -1vw;
        margin-top: 1.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
    /* .nav-main {
        display: flex;
        position: absolute;
        z-index: 1;
        top: 2.2vw;
        left: 0.8vw;
    }
    .logo-wrraper {
        width: 10vw;
        margin-left: 5.82vw;
        display: flex;
    } */
    .back-div {
        position: relative;
        height: 32.812vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 2vw;
        display: flex;
        margin-top: 4.1vw;
    }
    .front-div {
        position: absolute;
        width: 100%;
        height: 32.294vw;
        background: #ffffff;
        border-bottom-left-radius: 2vw;
        border-bottom-right-radius: 2vw;
        left: 22.25vw;
        bottom: 0.9vw;
    }

    .Form-Fee {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 3vw;
    }
    .Form-Fee_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 3vw;
    }
    /* select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("images/dropdown.svg");
        background-repeat: no-repeat;
        background-position-x: 17.4vw;
        background-position-y: 1vw;
        background-size: 0.6vw;
    } */
    .input_desktop {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        font-size: 0.926vw;
        margin-top: 0.397vw;
    }
    label {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    .input_desktop::placeholder {
        font-size: 0.926vw;
    }
    /* select {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        background-color: transparent;
        margin-top: 0.6vw;
        font-size: 0.926vw;
    } */
    .heading-mobile {
        font-size: 8.333vw;
        font-weight: 600;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        padding-top: 34.167vw;
    }
    .back-div-mobile {
        position: relative;
        height: 240vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.2vw;
    }
    .Form-Fee-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .Form-Fee_x-mobile {
        width: 73.889vw;
        font-size: 3.056vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .front-div-mobile {
        position: absolute;
        width: 92.778vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
        padding-bottom: 5vw;
        top: 45vw;
    }
    .input-mobile {
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        height: 9.111vw;
        font-size: 3.187vw;
    }
    .p-mobile {
        font-size: 3.056vw;
        margin-top: 6.667vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    /* .select-mobile {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url(images/dropdown.svg);
        background-repeat: no-repeat;
        background-position-x: 44.4vw;
        background-position-y: 3.5vw;
        background-size: 1.8vw;
    }
    .select-mobile {
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 1vw;
        height: 9.111vw;
        background-color: transparent;
    } */
    .heading {
        font-size: 3.307vw;
        font-weight: 600;
        text-align: center;
        margin-top: 14.815vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .pre {
        font-size: 1.323vw;
        color: #00204b;
        text-align: center;
        margin-bottom: 3.968vw;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
    }
</style>
